import { CollectionStatusEnum, CollectionStatusLabelEnum } from 'submodules/nerit-aquatec-sdk/common/enums/CollectionStatusEnum'
import { SelectFullOptionTP } from 'submodules/nerit-framework-ui/common/components/form-fields/select/inner/types/SelectOptionTP'

/**
 * Utilitarios de apresentacao do status de coleta (Tela 3.2 - Controle de Pontos).
 */
export class CollectionStatusUtils {

    /**
     * Cor da TagCP para cada status de coleta.
     */
    static getColor(status: CollectionStatusEnum): string {
        switch (status) {
            case CollectionStatusEnum.IMPORTED:
                return 'green'
            case CollectionStatusEnum.WAITING_COLLECTION:
                return 'orange'
            case CollectionStatusEnum.WAITING_IMPORT:
                return 'yellow'
            case CollectionStatusEnum.NOT_COLLECTED:
                return 'red'
            case CollectionStatusEnum.DRY_POINT:
                return 'darkOrange'
            default:
                return 'blue'
        }
    }

    /**
     * Label em PT para o status.
     */
    static getLabel(status: CollectionStatusEnum): string {
        return CollectionStatusLabelEnum[status] ?? status
    }

    /**
     * Opcoes para o select de status no modal da celula.
     */
    static getSelectOptions(): SelectFullOptionTP[] {
        return Object.values(CollectionStatusEnum).map((status) => ({
            value: status,
            label: CollectionStatusUtils.getLabel(status),
        }))
    }

}
